import { EditableText } from '@smartfire/components';
import {
    BlockWrapper,
    defineBlock,
    smartProps,
    useChildrenBlocks,
    useEditor,
    useInspectorControl,
} from '@smartfire/js-block-engine';
import { useSmartForm } from '@smartfire/wordpress-smartforms';
import React, { useCallback, useState } from 'react';
import { GuedelonSubmitButton } from '../bouton-guedelon/button';
import style from './block.module.scss';
import clsx from 'clsx';
import { ReactComponent as SmartfireIcon } from '../assets/smartfire_icone.svg';
import apiFetch from '@wordpress/api-fetch';
import { Alert } from '@mui/material';

const TEMPLATE = [
    ['smartfire/form---input', { label: 'Prénom *', input: { name: 'firstname', type: 'text', isRequired: true } }],
    ['smartfire/form---input', { label: 'Nom *', input: { name: 'lastname', type: 'text', isRequired: true } }],
];

async function submitForm(formData) {
    try {
        const result = await apiFetch<any>({
            path: 'smartforms/v1/submit',
            method: 'POST',
            body: formData,
        });
        return {
            success: true,
            message: result.message,
        };
    } catch (e: any) {
        if (e.success === false) {
            return {
                success: false,
                errors: e.errors,
            };
        } else {
            throw e;
        }
    }
}

const InspectorLazy = React.lazy(() => import('./Inspector'));
const Block = ({ thanksText, keyForm }) => {
    const { Form } = useSmartForm({ smartProp: 'myForm' });
    const { Children } = useChildrenBlocks();
    const { isEditing } = useEditor();
    const [submitMessage, setSubmitMessage] = useState<{ success: boolean; message: string }>();
    useInspectorControl(InspectorLazy, []);

    const formHandler = useCallback(async ({ formData }) => {
        const r = await submitForm(formData);
        if (r.success) {
            setSubmitMessage({ success: true, message: r.message });
        } else {
            setSubmitMessage({ success: false, message: r.errors[0].message });
        }
        return r;
    }, []);

    return (
        <BlockWrapper.Div className={style.block}>
            <div className={style.content}>
                <div className={clsx(style.guedelonForm, isEditing && style.editing)}>
                    {/* @ts-ignore form typing miss children */}
                    <Form onSmartFormSubmit={formHandler}>
                        <Children
                            gutenbergEditorConfig={{
                                template: TEMPLATE,
                                allowedBlocks: [
                                    'smartfire/form---input',
                                    'smartfire/form---textArea',
                                    'smartfire/form---acceptation',
                                    'smartfire/form---select',
                                ],
                            }}
                        />
                        <input type="hidden" id="key_form" name="key_form" value={keyForm} />
                        <GuedelonSubmitButton className={style.submit}>
                            <EditableText smartProp="sendBtnText" />
                        </GuedelonSubmitButton>
                    </Form>
                    {typeof submitMessage?.success !== 'undefined' && (
                        <Alert severity={submitMessage?.success ? 'success' : 'error'} className={style.alert}>
                            {submitMessage?.success ? thanksText : submitMessage?.message}
                        </Alert>
                    )}
                </div>
            </div>
        </BlockWrapper.Div>
    );
};

export default defineBlock({
    Block: Block as React.FC,
    setup: { title: 'Smartform', icon: SmartfireIcon },
    smartProps: {
        myForm: smartProps.object.withDefault({
            configuration: {
                emailTo: 'contact@test.fr',
                message: `Nouvelle demande de contact: Nom: [lastname]`,
                subject: 'contact',
                headers: 'From: [firstname] [lastname] <[email]>',
            },
        }),
        keyForm: smartProps.string.withDefault('contact'),
        sendBtnText: smartProps.string.withDefault('Envoyer'),
        thanksText: smartProps.string.withDefault('Le formulaire de contact a bien été envoyé.'),
    },
});
